<script lang="ts">
  import { Router, Route } from "svelte-routing";
  import { onDestroy, onMount } from "svelte";
  import { ResizeObserver } from "@juggle/resize-observer";

  import Register from "./Register.svelte";
  import Confirm from "./Confirm.svelte";
  import Login from "./Login.svelte";
  import { Analytics } from "firebase/analytics";

  export let analytics: Analytics;

  const ro = new ResizeObserver(() => {
    window.parent.postMessage(
      {
        eventName: "resize",
        details: {
          width: document.body.scrollWidth,
          height: document.body.scrollHeight,
        },
      },
      "https://www.kiwisignage.com"
    );
  });

  onMount(() => {
    ro.observe(document.body);
  });

  onDestroy(() => {
    ro.disconnect();
  });
</script>

<Router>
  <div>
    <Route path="/" component={Register} {analytics} />
    <Route path="/confirm" component={Confirm} {analytics} />
    <Route path="/login" component={Login} {analytics} />
  </div>
</Router>
